import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { CircularProgress, Grid, IconButton, TextField, Typography } from "@material-ui/core";
import AuthorizationWrapper from "../AuthorizationWrapper";
import articlesStore from "../../store/articles/ArticlesStore";
import { Autocomplete } from "@material-ui/lab";
import withIntl from "../../utils/withIntl";
import { getArticles } from "../../store/articles/ArticlesApi";
import { Remove } from "@material-ui/icons";

function PackagingsSettings(props) {
  const [value, setValue] = React.useState(props.setting.value ? props.setting.value : []);
  const [open, setOpen] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const [selectedOption, setSelectedOption] = React.useState(null);
  const [articles, setArticles] = React.useState(articlesStore.articles);

  let loading = open && options.length === 0;
  let merchantId = Number.parseInt(useParams().merchantId);

  useEffect(() => {
    if (merchantId !== articlesStore.merchantId || !articles) {
      getArticles(merchantId);
    }
  }, []);

  useEffect(() => {
    const onChangeArticles = () => {
      setArticles(articlesStore.articles);
    };
    articlesStore.on(articlesStore.events.MENU_UPDATED, onChangeArticles);
    return () => {
      articlesStore.removeListener(articlesStore.events.MENU_UPDATED, onChangeArticles);
    };
  }, []);

  const search = (searchValue) => {
    if (!articlesStore.articles) {
      return [];
    }

    return Object.keys(articlesStore.articles).reduce((articles, articleId) => {
      if (articles.length > 9) {
        return articles;
      }
      let searchValues = searchValue.split(/\s/);
      let article = articlesStore.articles[articleId];
      if (
        searchValues.every((value) => {
          if (value.length === 0) {
            return true;
          }
          if (
            article.name.toLowerCase().includes(value.toLowerCase()) ||
            article.plu.toLowerCase().includes(value.toLowerCase())
          ) {
            return true;
          }
          return false;
        })
      ) {
        articles.push(article);
      }

      return articles;
    }, []);
  };

  useEffect(() => {
    if (selectedOption) {
      setSelectedOption(null);
      let values = [];
      if (value) {
        values = [...value];
      }
      values.push({ id: selectedOption.id, name: selectedOption.name, price: selectedOption.price, amount: 1 });
      setValue(values);
      props.onChange(values);
    }
  }, [selectedOption]);

  useEffect(() => {
    let active = true;

    (async () => {
      const articles = await search(searchValue);
      if (active) {
        setOptions(articles);
      }
    })();

    return () => {
      active = false;
    };
  }, [searchValue]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  if (merchantId !== articlesStore.merchantId || !articlesStore.articles) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <AuthorizationWrapper
      permission={props.authenticationName}
      child={(write) => {
        return (
          <>
            <Typography>{props.label}</Typography>
            <Grid container spacing={1}>
              {value.map((item, index) => (
                <>
                  <Grid item xs={10}>
                    {item.name}
                  </Grid>
                  <Grid item xs={2}>
                    <IconButton
                      size={"small"}
                      onClick={() => {
                        let newValues = [...value];
                        newValues.splice(index, 1);
                        props.onChange(newValues);
                        setValue(newValues);
                      }}
                    >
                      <Remove />
                    </IconButton>
                  </Grid>
                </>
              ))}
            </Grid>

            <Autocomplete
              style={{ width: 300 }}
              open={open}
              onOpen={() => {
                setOpen(true);
              }}
              onClose={() => {
                setOpen(false);
                setSearchValue("");
              }}
              filterOptions={(x) => x}
              onChange={(e, value) => {
                if (value) {
                  setSelectedOption(value);
                }
              }}
              onInputChange={(event, value) => {
                setSearchValue(value);
              }}
              getOptionSelected={(option, value) => {
                return option.merchantId === value.merchantId && option.serviceId === value.serviceId;
              }}
              getOptionLabel={(option) => option.name + " - " + option.plu}
              options={options}
              loading={loading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={props.intl.formatMessage({ id: "Search" })}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />

            {props.children}
          </>
        );
      }}
    />
  );
}

export default withIntl(PackagingsSettings);
